<template>
  <div :class="{'menu-open': $store.state.menuOpen}" class="app" @click="closeMenu">
    <side-menu></side-menu>
    <AppHeader/>
    <div class="app-body">
        <div class="container-fluid">
            <router-view></router-view>
        </div>
    </div>
    <AppFooter v-if="!hideFooter" />
  </div>
</template>

<script>
import { Header as AppHeader, Footer as AppFooter, SideMenu } from '../components'

export default {
  name: 'full',
  components: {
    AppHeader, AppFooter, SideMenu
  },
  data () {
    return {
      
    }
  },
  methods: {
    closeMenu () {
      if (this.$store.state.menuOpen) {
        this.$store.commit('toggleMenu')
      }
    }
  },
  computed: {
    label () {
        return (typeof this.$route.meta.label !== 'undefined') ? this.$route.meta.label.toLowerCase() : ''
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    },
    hideFooter () {
      return this.$route.meta && this.$route.meta.hideFooter;
    }
  },
  created () {
    // if (this.user) {
      this.$store.dispatch('tag/fetch')
      this.$store.dispatch('talent/fetch')
    // }
  }
}
</script>



// WEBPACK FOOTER //
// prompts/containers/Full.vue